// oil.js - Oil Change Form Component with MoboOil Millage
import React, { useState, useEffect, useRef, useCallback, memo } from 'react';
import { useAuth } from '../pages/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./Styles/ServUI.css";
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';

import {
    faWrench, faUser, faPhone, faMapMarkerAlt, faCalendarAlt, faFileInvoice, faBox, faRupeeSign, faTag,
    faCar, faIdCard, faCreditCard, faMoneyBill, faPercent, faReceipt, faChevronDown, faChevronUp,
    faPlus, faMinus, faTrash, faSave, faTimes, faSpinner, faCheckCircle, faExclamationCircle,
    faExclamationTriangle, faSearch, faBarcode, faUsers, faClock, faHistory, faPrint, faEye,
    faExchangeAlt, faCopy, faFileAlt, faTrashAlt, faUserPlus, faCalendarDay, faHashtag,
    faRupeeSign as faCurrencyRupee, faCreditCard as faPayment, faOilCan, faTachometerAlt, faRoad, faCalendarCheck
} from '@fortawesome/free-solid-svg-icons';

const API_BASE = 'https://ourzestapp.online/oz_backend/mechanics_module';
const OIL_API = `${API_BASE}/mechanics_mobchange.php`;
const CUSTOMER_API = `${API_BASE}/mechanics_customers.php`;
const PRODUCT_API = `${API_BASE}/mechanics_products.php`;
const EMPLOYEE_API = `${API_BASE}/mechanics_employees.php`;
const CARS_API = `${API_BASE}/mechanics_cars.php`;

// ----------------------- TRANSLATOR -----------------------
const createOilTranslator = () => {
    let cache = new Map();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) {
            console.log("No cache found in Oil Form");
        }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_translations', JSON.stringify(cacheObj));
        } catch (e) {
            console.error("Error saving to cache:", e);
        }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'New Oil Change': 'نیا آئل چینج',
                'Edit Oil Change': 'آئل چینج میں ترمیم کریں',
                'Create and manage oil change requests': 'آئل چینج کی درخواستیں بنائیں اور ان کا نظم کریں',
                'Update oil change details': 'آئل چینج کی تفصیلات کو اپ ڈیٹ کریں',
                'Save': 'محفوظ کریں',
                'Saving...': 'محفوظ کر رہے ہیں...',
                'Clear': 'صاف کریں',
                'Update Oil Change': 'آئل چینج اپ ڈیٹ کریں',
                'Create Oil Change': 'آئل چینج بنائیں',
                'Oil change saved successfully!': 'آئل چینج کامیابی سے محفوظ ہو گئی!',
                'Oil change updated successfully!': 'آئل چینج کامیابی سے اپ ڈیٹ ہو گئی!',
                'Failed to save oil change': 'آئل چینج محفوظ کرنے میں ناکامی',
                'Network error occurred': 'نیٹ ورک کی خرابی',
                'Please wait, already processing...': 'براہ کرم انتظار کریں، پہلے سے عمل میں ہے...',
                'Please fix the errors before submitting': 'براہ کرم جمع کرانے سے پہلے غلطیاں درست کریں',
                'Walking Customer': 'واکنگ کسٹمر',
                'Search Customer': 'کسٹمر تلاش کریں',
                'Car Model': 'کار ماڈل',
                'Number Plate': 'نمبر پلیٹ',
                'Search Products': 'پروڈکٹس تلاش کریں',
                'Oil Type': 'آئل کی قسم',
                'Oil Quantity': 'آئل کی مقدار',
                'Filter Type': 'فلٹر کی قسم',
                'Products Total': 'پروڈکٹس کل',
                'Subtotal': 'ذیلی کل',
                'Discount': 'چھوٹ',
                'Grand Total': 'کل رقم',
                'Paid Amount': 'ادا کردہ رقم',
                'Balance': 'باقی رقم',
                'Payment Method': 'ادائیگی کا طریقہ',
                'Status': 'حالت',
                'Additional Notes': 'اضافی نوٹس',
                'Notes': 'نوٹس',
                'Cash': 'نقد',
                'Card': 'کارڈ',
                'Bank Transfer': 'بینک ٹرانسفر',
                'Pending': 'زیر التواء',
                'In Progress': 'جاری',
                'Completed': 'مکمل',
                'Delivered': 'ڈیلیور شدہ',
                'Cancelled': 'منسوخ',
                'Add Employee': 'ملازم شامل کریں',
                'No employees available': 'کوئی ملازم دستیاب نہیں',
                'Task Based Employees Payment': 'ٹاسک بیسڈ ملازمین کی ادائیگی',
                'Net Receivable': 'خالص قابل وصول',
                'Switch Shop': 'شاپ تبدیل کریں',
                'No shop selected': 'کوئی شاپ منتخب نہیں',
                'Select a shop first': 'پہلے ایک شاپ منتخب کریں',
                'Shop switched successfully': 'شاپ کامیابی سے تبدیل ہو گئی',
                'Failed to switch shop': 'شاپ تبدیل کرنے میں ناکامی',
                'Current Shop': 'موجودہ شاپ',
                'Loading shops...': 'شاپس لوڈ ہو رہی ہیں...',
                'No shops available': 'کوئی شاپ دستیاب نہیں',
                'Current': 'موجودہ',
                'Save Draft': 'ڈرافٹ محفوظ کریں',
                'Drafts': 'ڈرافٹس',
                'Saved Drafts': 'محفوظ کردہ ڈرافٹس',
                'Clear Form': 'فارم صاف کریں',
                'View Drafts': 'ڈرافٹس دیکھیں',
                'No drafts saved': 'کوئی ڈرافٹ محفوظ نہیں',
                'Draft saved successfully!': 'ڈرافٹ کامیابی سے محفوظ ہو گیا!',
                'Draft loaded successfully!': 'ڈرافٹ کامیابی سے لوڈ ہو گیا!',
                'Draft deleted successfully!': 'ڈرافٹ کامیابی سے حذف ہو گیا!',
                'Cannot save empty draft': 'خالی ڈرافٹ محفوظ نہیں کر سکتے',
                'Unnamed Oil Change': 'نامعلوم آئل چینج',
                'Success': 'کامیابی',
                'Error': 'خرابی',
                'Warning': 'انتباہ',
                'Create Payment': 'ادائیگی بنائیں',
                'Payment Details': 'ادائیگی کی تفصیلات',
                'Close': 'بند کریں',
                'Engine Oil': 'انجن آئل',
                'Gear Oil': 'گیئر آئل',
                'Brake Fluid': 'بریک فلوئڈ',
                'Coolant': 'کولنٹ',
                'Power Steering': 'پاور اسٹیئرنگ',
                'Transmission Fluid': 'ٹرانسمیشن فلوئڈ',
                'Oil Filter': 'آئل فلٹر',
                'Air Filter': 'ایئر فلٹر',
                'Fuel Filter': 'فیول فلٹر',
                'Cabin Filter': 'کیبن فلٹر',
                'Mobo Oil Millage': 'موبائل آئل مائلیج',
                'Next Change': 'اگلی تبدیلی',
                'Receipt': 'رسید',
                'Print Receipt': 'رسید پرنٹ کریں',
                'Print Barcode': 'بارکوڈ پرنٹ کریں',
                'Barcode': 'بارکوڈ'
            },
            'ar': {
                'New Oil Change': 'تغيير الزيت الجديد',
                'Edit Oil Change': 'تحرير تغيير الزيت',
                'Create and manage oil change requests': 'إنشاء وإدارة طلبات تغيير الزيت',
                'Update oil change details': 'تحديث تفاصيل تغيير الزيت',
                'Save': 'حفظ',
                'Saving...': 'جاري الحفظ...',
                'Clear': 'مسح',
                'Update Oil Change': 'تحديث تغيير الزيت',
                'Create Oil Change': 'إنشاء تغيير الزيت',
                'Oil change saved successfully!': 'تم حفظ تغيير الزيت بنجاح!',
                'Oil change updated successfully!': 'تم تحديث تغيير الزيت بنجاح!',
                'Failed to save oil change': 'فشل في حفظ تغيير الزيت',
                'Network error occurred': 'حدث خطأ في الشبكة',
                'Please wait, already processing...': 'يرجى الانتظار، جاري المعالجة...',
                'Please fix the errors before submitting': 'يرجى إصلاح الأخطاء قبل الإرسال',
                'Walking Customer': 'عميل عابر',
                'Search Customer': 'بحث عن عميل',
                'Car Model': 'موديل السيارة',
                'Number Plate': 'لوحة الأرقام',
                'Search Products': 'بحث عن منتجات',
                'Oil Type': 'نوع الزيت',
                'Oil Quantity': 'كمية الزيت',
                'Filter Type': 'نوع الفلتر',
                'Products Total': 'إجمالي المنتجات',
                'Subtotal': 'المجموع الفرعي',
                'Discount': 'خصم',
                'Grand Total': 'المجموع الكلي',
                'Paid Amount': 'المبلغ المدفوع',
                'Balance': 'الرصيد',
                'Payment Method': 'طريقة الدفع',
                'Status': 'الحالة',
                'Additional Notes': 'ملاحظات إضافية',
                'Notes': 'ملاحظات',
                'Cash': 'نقدي',
                'Card': 'بطاقة',
                'Bank Transfer': 'تحويل بنكي',
                'Pending': 'قيد الانتظار',
                'In Progress': 'قيد التنفيذ',
                'Completed': 'مكتمل',
                'Delivered': 'تم التوصيل',
                'Cancelled': 'ملغي',
                'Add Employee': 'إضافة موظف',
                'No employees available': 'لا يوجد موظفين متاحين',
                'Task Based Employees Payment': 'دفع الموظفين على أساس المهمة',
                'Net Receivable': 'صافي المستحق',
                'Switch Shop': 'تبديل المتجر',
                'No shop selected': 'لم يتم اختيار متجر',
                'Select a shop first': 'اختر متجرًا أولاً',
                'Shop switched successfully': 'تم تبديل المتجر بنجاح',
                'Failed to switch shop': 'فشل في تبديل المتجر',
                'Current Shop': 'المتجر الحالي',
                'Loading shops...': 'جاري تحميل المتاجر...',
                'No shops available': 'لا توجد متاجر متاحة',
                'Current': 'حالي',
                'Save Draft': 'حفظ المسودة',
                'Drafts': 'المسودات',
                'Saved Drafts': 'المسودات المحفوظة',
                'Clear Form': 'مسح النموذج',
                'View Drafts': 'عرض المسودات',
                'No drafts saved': 'لا توجد مسودات محفوظة',
                'Draft saved successfully!': 'تم حفظ المسودة بنجاح!',
                'Draft loaded successfully!': 'تم تحميل المسودة بنجاح!',
                'Draft deleted successfully!': 'تم حذف المسودة بنجاح!',
                'Cannot save empty draft': 'لا يمكن حفظ مسودة فارغة',
                'Unnamed Oil Change': 'تغيير زيت بدون اسم',
                'Success': 'نجاح',
                'Error': 'خطأ',
                'Warning': 'تحذير',
                'Create Payment': 'إنشاء دفعة',
                'Payment Details': 'تفاصيل الدفع',
                'Close': 'إغلاق',
                'Mobo Oil Millage': 'مسافة زيت الموبو',
                'Next Change': 'التغيير التالي',
                'Receipt': 'إيصال',
                'Print Receipt': 'طباعة الإيصال',
                'Print Barcode': 'طباعة الباركود',
                'Barcode': 'باركود'
            },
            'es': {
                'New Oil Change': 'Cambio de Aceite Nuevo',
                'Edit Oil Change': 'Editar Cambio de Aceite',
                'Create and manage oil change requests': 'Crear y gestionar solicitudes de cambio de aceite',
                'Update oil change details': 'Actualizar detalles del cambio de aceite',
                'Save': 'Guardar',
                'Saving...': 'Guardando...',
                'Clear': 'Limpiar',
                'Update Oil Change': 'Actualizar Cambio de Aceite',
                'Create Oil Change': 'Crear Cambio de Aceite',
                'Oil change saved successfully!': '¡Cambio de aceite guardado exitosamente!',
                'Oil change updated successfully!': '¡Cambio de aceite actualizado exitosamente!',
                'Failed to save oil change': 'Error al guardar el cambio de aceite',
                'Network error occurred': 'Ocurrió un error de red',
                'Please wait, already processing...': 'Por favor espere, ya procesando...',
                'Please fix the errors before submitting': 'Por favor corrija los errores antes de enviar',
                'Walking Customer': 'Cliente Walk-in',
                'Search Customer': 'Buscar Cliente',
                'Car Model': 'Modelo de Auto',
                'Number Plate': 'Placa',
                'Search Products': 'Buscar Productos',
                'Oil Type': 'Tipo de Aceite',
                'Oil Quantity': 'Cantidad de Aceite',
                'Filter Type': 'Tipo de Filtro',
                'Products Total': 'Total Productos',
                'Subtotal': 'Subtotal',
                'Discount': 'Descuento',
                'Grand Total': 'Total General',
                'Paid Amount': 'Monto Pagado',
                'Balance': 'Saldo',
                'Payment Method': 'Método de Pago',
                'Status': 'Estado',
                'Additional Notes': 'Notas Adicionales',
                'Notes': 'Notas',
                'Cash': 'Efectivo',
                'Card': 'Tarjeta',
                'Bank Transfer': 'Transferencia Bancaria',
                'Pending': 'Pendiente',
                'In Progress': 'En Progreso',
                'Completed': 'Completado',
                'Delivered': 'Entregado',
                'Cancelled': 'Cancelado',
                'Add Employee': 'Agregar Empleado',
                'No employees available': 'No hay empleados disponibles',
                'Task Based Employees Payment': 'Pago de Empleados por Tarea',
                'Net Receivable': 'Neto por Cobrar',
                'Switch Shop': 'Cambiar Tienda',
                'No shop selected': 'No se seleccionó ninguna tienda',
                'Select a shop first': 'Seleccione una tienda primero',
                'Shop switched successfully': 'Tienda cambiada exitosamente',
                'Failed to switch shop': 'Error al cambiar de tienda',
                'Current Shop': 'Tienda Actual',
                'Loading shops...': 'Cargando tiendas...',
                'No shops available': 'No hay tiendas disponibles',
                'Current': 'Actual',
                'Save Draft': 'Guardar Borrador',
                'Drafts': 'Borradores',
                'Saved Drafts': 'Borradores Guardados',
                'Clear Form': 'Limpiar Formulario',
                'View Drafts': 'Ver Borradores',
                'No drafts saved': 'No hay borradores guardados',
                'Draft saved successfully!': '¡Borrador guardado exitosamente!',
                'Draft loaded successfully!': '¡Borrador cargado exitosamente!',
                'Draft deleted successfully!': '¡Borrador eliminado exitosamente!',
                'Cannot save empty draft': 'No se puede guardar un borrador vacío',
                'Unnamed Oil Change': 'Cambio de aceite sin nombre',
                'Success': 'Éxito',
                'Error': 'Error',
                'Warning': 'Advertencia',
                'Create Payment': 'Crear Pago',
                'Payment Details': 'Detalles de Pago',
                'Close': 'Cerrar',
                'Mobo Oil Millage': 'Millaje de Aceite Mobo',
                'Next Change': 'Próximo Cambio',
                'Receipt': 'Recibo',
                'Print Receipt': 'Imprimir Recibo',
                'Print Barcode': 'Imprimir Código de Barras',
                'Barcode': 'Código de Barras'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) {
            console.log("LibreTranslate failed, trying MyMemory");
        }

        try {
            const response = await fetch(
                `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
            );
            if (response.ok) {
                const data = await response.json();
                return data.responseData.translatedText;
            }
        } catch (e) {
            console.log("MyMemory translation failed");
        }

        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;

        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }

        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();

        return translated;
    };

    const defaultTexts = {
        newOilChange: 'New Oil Change',
        editOilChange: 'Edit Oil Change',
        createDesc: 'Create and manage oil change requests',
        editDesc: 'Update oil change details',
        save: 'Save',
        saving: 'Saving...',
        clear: 'Clear',
        updateOilChange: 'Update Oil Change',
        createOilChange: 'Save Oil Change',
        oilSaved: 'Oil change saved successfully!',
        oilUpdated: 'Oil change updated successfully!',
        failedSave: 'Failed to save oil change',
        networkError: 'Network error occurred',
        pleaseWait: 'Please wait, already processing...',
        fixErrors: 'Please fix the errors before submitting',
        walkingCustomer: 'Walking Customer',
        searchCustomer: 'Search Customer',
        carModel: 'Car Model',
        numberPlate: 'Number Plate',
        searchProducts: 'Search Products',
        oilType: 'Oil Type',
        oilQuantity: 'Oil Quantity',
        filterType: 'Filter Type',
        productsTotal: 'Products Total',
        subtotal: 'Subtotal',
        discount: 'Discount',
        grandTotal: 'Grand Total',
        paidAmount: 'Paid Amount',
        balance: 'Balance',
        paymentMethod: 'Payment Method',
        status: 'Status',
        additionalNotes: 'Additional Notes',
        notes: 'Notes',
        cash: 'Cash',
        card: 'Card',
        bankTransfer: 'Bank Transfer',
        pending: 'Pending',
        inProgress: 'In Progress',
        completed: 'Completed',
        delivered: 'Delivered',
        cancelled: 'Cancelled',
        addEmployee: 'Add Employee',
        noEmployees: 'No employees available',
        taskBasedPayment: 'Task Based Employees Payment',
        netReceivable: 'Net Receivable',
        switchShop: 'Switch Shop',
        noShopSelected: 'No shop selected',
        selectShopFirst: 'Select a shop first',
        shopSwitched: 'Shop switched successfully',
        shopSwitchFailed: 'Failed to switch shop',
        currentShop: 'Current Shop',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        current: 'Current',
        saveDraft: 'Save Draft',
        drafts: 'Drafts',
        savedDrafts: 'Saved Drafts',
        clearForm: 'Clear Form',
        viewDrafts: 'View Drafts',
        noDraftsSaved: 'No drafts saved',
        draftSaved: 'Draft saved successfully!',
        draftLoaded: 'Draft loaded successfully!',
        draftDeleted: 'Draft deleted successfully!',
        cannotSaveEmpty: 'Cannot save empty draft',
        unnamedOilChange: 'Unnamed Oil Change',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        createPayment: 'Payment',
        paymentDetails: 'Payment Details',
        close: 'Close',
        moboOilMillage: 'Mobo Oil Millage',
        nextChange: 'Next Change',
        receipt: 'Receipt',
        printReceipt: 'Print Receipt',
        printBarcode: 'Print QR Code',
        barcode: 'QR Code'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') {
            return defaultTexts;
        }

        const translations = {};
        const promises = [];

        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });

        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }

        return translations;
    };

    loadFromCache();

    return {
        getTranslations,
        translateText
    };
};

const oilTranslator = createOilTranslator();

// Helper functions for oil type and filter type labels
const getOilTypeLabel = (value) => {
    const oilTypes = {
        'engine_oil': 'Engine Oil',
        'gear_oil': 'Gear Oil',
        'brake_fluid': 'Brake Fluid',
        'coolant': 'Coolant',
        'power_steering': 'Power Steering',
        'transmission_fluid': 'Transmission Fluid'
    };
    return oilTypes[value] || value || '';
};

const getFilterTypeLabel = (value) => {
    const filterTypes = {
        'oil_filter': 'Oil Filter',
        'air_filter': 'Air Filter',
        'fuel_filter': 'Fuel Filter',
        'cabin_filter': 'Cabin Filter'
    };
    return filterTypes[value] || value || '';
};

// ----------------------- CUSTOM CAR DROPDOWN COMPONENT -----------------------
const CarDropdown = ({ value, onChange, shopId, translations }) => {
    const [cars, setCars] = useState([]);
    const [loadingCars, setLoadingCars] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [searchTerm, setSearchTerm] = useState(value || '');
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);

    const handleKeyDown = (e) => {
        if (e.key === 'Tab') {
            setShowDropdown(false);
            return;
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const fetchCars = async () => {
        if (!shopId) return;
        setLoadingCars(true);
        try {
            const response = await fetch(CARS_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_cars', shop_id: shopId, limit: 200 })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setCars(data.data || []);
            }
        } catch (error) {
            console.error('Error fetching cars:', error);
        } finally {
            setLoadingCars(false);
        }
    };

    useEffect(() => {
        if (shopId) {
            fetchCars();
        }
    }, [shopId]);

    const filteredCars = searchTerm.trim() === ''
        ? cars
        : cars.filter(car =>
            car.car_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (car.serial_number && car.serial_number.toLowerCase().includes(searchTerm.toLowerCase()))
        );

    const selectCar = (car) => {
        setSearchTerm(car.car_name);
        onChange(car.car_name);
        setShowDropdown(false);
    };

    return (
        <div className="ozserui-custom-dropdown" ref={dropdownRef}>
            <div className="ozserui-input-wrapper">
                <FontAwesomeIcon icon={faCar} className="ozserui-input-icon" />
                <input
                    ref={inputRef}
                    type="text"
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        onChange(e.target.value);
                        setShowDropdown(true);
                    }}
                    onFocus={() => setShowDropdown(true)}
                    onKeyDown={handleKeyDown}
                    placeholder=" "
                    autoComplete="off"
                />
                <label>{translations.carModel || 'Car Model'}</label>
                <FontAwesomeIcon icon={faChevronDown} className="ozserui-dropdown-arrow" />
            </div>
            {showDropdown && (
                <div className="ozserui-dropdown-menu">
                    {loadingCars ? (
                        <div className="ozserui-dropdown-loading">
                            <FontAwesomeIcon icon={faSpinner} spin /> Loading cars...
                        </div>
                    ) : filteredCars.length === 0 ? (
                        <div className="ozserui-dropdown-empty">No cars found</div>
                    ) : (
                        filteredCars.map(car => (
                            <div
                                key={car.car_id}
                                className="ozserui-dropdown-item"
                                onClick={() => selectCar(car)}
                            >
                                <div className="ozserui-dropdown-item-name">{car.car_name}</div>
                                {car.serial_number && (
                                    <div className="ozserui-dropdown-item-sub">#{car.serial_number}</div>
                                )}
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

// ----------------------- TOAST -----------------------
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations.success || 'Success';
            case 'error': return translations.error || 'Error';
            case 'warning': return translations.warning || 'Warning';
            default: return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};

// ----------------------- SHOP SELECTOR MODAL -----------------------
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="ozserui-modal-overlay" onClick={onClose}>
            <div className="ozserui-modal" onClick={e => e.stopPropagation()}>
                <div className="ozserui-modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="ozserui-modal-close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozserui-modal-body">
                    {loading ? (
                        <div className="ozserui-loading-state">{translations.loadingShops || 'Loading shops...'}</div>
                    ) : shops.length === 0 ? (
                        <div className="ozserui-empty-state">{translations.noShops || 'No shops available'}</div>
                    ) : (
                        shops.map((shop) => (
                            <div
                                key={shop.shop_id}
                                className={`ozserui-shop-item ${currentShop?.shop_id === shop.shop_id ? 'ozserui-active' : ''}`}
                                onClick={() => onSelectShop(shop)}
                            >
                                <div className="ozserui-shop-info">
                                    <div className="ozserui-shop-name">{shop.shop_name}</div>
                                    <div className="ozserui-shop-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                </div>
                                {currentShop?.shop_id === shop.shop_id && (
                                    <div className="ozserui-shop-badge">✓ {translations.current || 'Current'}</div>
                                )}
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

// ----------------------- PRODUCT USED COMPONENT -----------------------
const ProductUsed = ({ product, index, onUpdate, onRemove, translations }) => {
    const [inputValue, setInputValue] = useState(
        product.quantity != null ? product.quantity.toString() : '1'
    );

    useEffect(() => {
        const currentNum = inputValue === '' ? 0 : parseFloat(inputValue);
        if (product.quantity !== currentNum && !isNaN(product.quantity)) {
            setInputValue(product.quantity.toString());
        }
    }, [product.quantity]);

    const handleChange = (e) => {
        const rawValue = e.target.value;
        if (rawValue === '' || rawValue === null) {
            setInputValue('0');
            onUpdate(index, 'quantity', 0);
            return;
        }
        setInputValue(rawValue);
        const numValue = parseFloat(rawValue);
        if (!isNaN(numValue)) {
            onUpdate(index, 'quantity', numValue);
        }
    };

    const handleBlur = () => {
        const numValue = parseFloat(inputValue);
        if (inputValue === '' || isNaN(numValue) || numValue < 0) {
            setInputValue('0');
            onUpdate(index, 'quantity', 0);
        } else {
            setInputValue(numValue.toString());
            onUpdate(index, 'quantity', numValue);
        }
    };

    const handleFocus = (e) => {
        e.target.select();
    };

    const price = Number(product.price_per_unit) || 0;
    const quantity = Number(product.quantity) || 0;
    const total = (price * quantity).toFixed(2);

    return (
        <div className="ozserui-product-used-card">
            <div className="ozserui-product-used-info">
                <div className="ozserui-product-name">{product.product_name}</div>
                {product.product_code && <div className="ozserui-product-code">{product.product_code}</div>}
                {product.batch_no && <div className="ozserui-batch-info">Batch: {product.batch_no}</div>}
            </div>
            <div className="ozserui-product-used-details">
                <div className="ozserui-form-group ozserui-small">
                    <label>Quantity</label>
                    <input
                        type="number"
                        value={inputValue}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onFocus={handleFocus}
                        step="0.001"
                        min="0"
                        placeholder="0"
                    />
                    <small>{product.unit || 'units'}</small>
                </div>
                <div className="ozserui-form-group ozserui-small">
                    <label>Price/Unit (Rs.)</label>
                    <input
                        type="number"
                        value={product.price_per_unit}
                        readOnly
                    />
                </div>
                <div className="ozserui-product-total">
                    <span>Total: Rs. {total}</span>
                </div>
                <button type="button" className="ozserui-remove-product-btn" onClick={() => onRemove(index)}>
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            </div>
        </div>
    );
};

// ----------------------- FINANCIAL SUMMARY -----------------------
const FinancialSummaryContent = memo(({ selectedProducts, formData, taskBasedTotal, netReceivable, translations, handleChange }) => (
    <>
        <div className="ozserui-summary-row">
            <span>{translations.productsTotal || 'Products Total'}:</span>
            <span>Rs. {selectedProducts.reduce((sum, p) => sum + ((Number(p.price_per_unit) || 0) * (Number(p.quantity) || 0)), 0).toFixed(2)}</span>
        </div>
        <div className="ozserui-summary-row">
            <span>{translations.subtotal || 'Subtotal'}:</span>
            <span>Rs. {formData.subtotal.toFixed(2)}</span>
        </div>
        <div className="ozserui-summary-row">
            <span>{translations.discount || 'Discount'} (Rs.):</span>
            <input type="number" name="discount" value={formData.discount} onChange={handleChange} step="0.01" min="0" />
        </div>

        {taskBasedTotal > 0 && (
            <>
                <div className="ozserui-summary-row">
                    <span>{translations.taskBasedPayment || 'Task Based Employees Payment'}:</span>
                    <span className="ozserui-task-based-amount">- Rs. {taskBasedTotal.toFixed(2)}</span>
                </div>
                <div className="ozserui-summary-row ozserui-net-receivable">
                    <span>{translations.netReceivable || 'Net Receivable'}:</span>
                    <span className="ozserui-net-amount">Rs. {netReceivable.toFixed(2)}</span>
                </div>
            </>
        )}

        <div className="ozserui-summary-row ozserui-grand-total">
            <span>{translations.grandTotal || 'Grand Total'}:</span>
            <span>Rs. {formData.grand_total.toFixed(2)}</span>
        </div>
        <div className="ozserui-summary-row">
            <span>{translations.paidAmount || 'Paid Amount'} (Rs.):</span>
            <input type="number" name="paid_amount" value={formData.paid_amount} onChange={handleChange} step="0.01" min="0" max={formData.grand_total} />
        </div>
        <div className="ozserui-summary-row">
            <span>{translations.balance || 'Balance'}:</span>
            <span className={formData.balance > 0 ? 'ozserui-balance-due' : 'ozserui-balance-zero'}>Rs. {formData.balance.toFixed(2)}</span>
        </div>
    </>
));

// ----------------------- PAYMENT MODAL -----------------------
const PaymentModal = memo(({ showPaymentModal, setShowPaymentModal, translations, selectedProducts, formData, taskBasedTotal, netReceivable, handleChange }) => {
    if (!showPaymentModal) return null;

    return (
        <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
            <div
                className="ozlistui-modal-content ozlistui-edit-modal-content"
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: '550px',
                    maxWidth: '90vw',
                    maxHeight: '85vh'
                }}
            >
                <div className="ozlistui-modal-header">
                    <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faPayment} /></div>
                    <div className="ozlistui-modal-title">
                        <h3>{translations.paymentDetails || 'Payment Details'}</h3>
                    </div>
                    <button className="ozlistui-close-btn" onClick={() => setShowPaymentModal(false)}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>

                <div className="ozlistui-modal-body">
                    <div className="ozserui-financial-summary" style={{ padding: 0 }}>
                        <FinancialSummaryContent
                            selectedProducts={selectedProducts}
                            formData={formData}
                            taskBasedTotal={taskBasedTotal}
                            netReceivable={netReceivable}
                            translations={translations}
                            handleChange={handleChange}
                        />
                    </div>
                </div>

                <div className="ozlistui-modal-footer">
                    <button
                        type="button"
                        className="ozlistui-btn ozlistui-btn-secondary"
                        onClick={() => setShowPaymentModal(false)}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                        {translations.close || 'Close'}
                    </button>
                </div>
            </div>
        </div>
    );
});

// ----------------------- MAIN OIL FORM COMPONENT -----------------------
const OilForm = ({ oilId = null, onSuccess = null }) => {
    const { user, currentShop, switchShop, getShopsForSwitch, businessInfo } = useAuth();
    const [shopId, setShopId] = useState(() => {
        if (user?.shop_id) return user.shop_id;
        return localStorage.getItem('current_shop_id') || '';
    });

    const customerSearchInputRef = useRef(null);
    const [translations, setTranslations] = useState({});
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [errors, setErrors] = useState({});
    const [toast, setToast] = useState({ show: false, type: '', message: '' });
    const [darkMode, setDarkMode] = useState(() => localStorage.getItem('ourzest_darkMode') === 'true');
    const [currentThemeColor, setCurrentThemeColor] = useState(() => localStorage.getItem('ourzest_theme') || '#6366f1');
    const [currentLanguage, setCurrentLanguage] = useState(() => localStorage.getItem('ourzest_language') || 'en');

    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);

    const [showDraftsList, setShowDraftsList] = useState(false);
    const [savedDrafts, setSavedDrafts] = useState([]);
    const draftsDropdownRef = useRef(null);

    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
    const [customerSearchTerm, setCustomerSearchTerm] = useState('');
    const [searchingCustomer, setSearchingCustomer] = useState(false);
    
    // ADDED: Manual phone number state
    const [manualPhoneNumber, setManualPhoneNumber] = useState('');

    const [employees, setEmployees] = useState([]);

    const [products, setProducts] = useState([]);
    const [productSearchTerm, setProductSearchTerm] = useState('');
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const [searchingProduct, setSearchingProduct] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);

    const [oilDetails, setOilDetails] = useState({
        oil_type: '',
        oil_quantity: '',
        filter_type: '',
        oil_brand: ''
    });

    const [moboOilMillage, setMoboOilMillage] = useState('');
    const [nextChange, setNextChange] = useState('');

    const [showPaymentMethodDropdown, setShowPaymentMethodDropdown] = useState(false);
    const [showStatusDropdown, setShowStatusDropdown] = useState(false);
    const paymentMethodRef = useRef(null);
    const statusRef = useRef(null);

    const [showPaymentModal, setShowPaymentModal] = useState(false);

    useEffect(() => {
        if (customerSearchInputRef.current) {
            customerSearchInputRef.current.focus();
        }
    }, []);

    const handleCustomerKeyDown = (e) => {
        if (e.key === 'Tab') {
            setShowCustomerDropdown(false);
            return;
        }
    };

    const handleProductKeyDown = (e) => {
        if (e.key === 'Tab') {
            setShowProductDropdown(false);
            return;
        }
    };

    const handlePaymentMethodKeyDown = (e) => {
        if (e.key === 'Tab') {
            setShowPaymentMethodDropdown(false);
            return;
        }
    };

    const handleStatusKeyDown = (e) => {
        if (e.key === 'Tab') {
            setShowStatusDropdown(false);
            return;
        }
    };

    const [formData, setFormData] = useState({
        date: new Date().toISOString().split('T')[0],
        oil_number: '',
        car_model: '',
        car_number_plate: '',
        car_color: '',
        car_year: '',
        odometer_reading: '',
        vehicle_type: '',
        subtotal: 0,
        tax: 0,
        discount: 0,
        grand_total: 0,
        paid_amount: 0,
        balance: 0,
        payment_method: 'cash',
        status: 'completed',
        notes: '',
        themeColor: localStorage.getItem('ourzest_theme') || '#6366f1'
    });

    const paymentMethods = [
        { value: 'cash', label: 'Cash' },
        { value: 'card', label: 'Card' },
        { value: 'bank_transfer', label: 'Bank Transfer' }
    ];

    const statusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'in_progress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' },
    ];

    const customerSearchRef = useRef(null);
    const productSearchRef = useRef(null);
    const isSavingRef = useRef(false);

    const oilTypeOptions = [
        { value: 'engine_oil', label: 'Engine Oil' },
        { value: 'gear_oil', label: 'Gear Oil' },
        { value: 'brake_fluid', label: 'Brake Fluid' },
        { value: 'coolant', label: 'Coolant' },
        { value: 'power_steering', label: 'Power Steering' },
        { value: 'transmission_fluid', label: 'Transmission Fluid' }
    ];

    const filterTypeOptions = [
        { value: 'oil_filter', label: 'Oil Filter' },
        { value: 'air_filter', label: 'Air Filter' },
        { value: 'fuel_filter', label: 'Fuel Filter' },
        { value: 'cabin_filter', label: 'Cabin Filter' }
    ];

    const calculateNextChange = useCallback(() => {
        const currentReading = parseFloat(formData.odometer_reading);
        const millage = parseFloat(moboOilMillage);

        if (!isNaN(currentReading) && !isNaN(millage) && millage > 0) {
            const nextChangeValue = currentReading + millage;
            setNextChange(nextChangeValue.toString());
        } else {
            setNextChange('');
        }
    }, [formData.odometer_reading, moboOilMillage]);

    useEffect(() => {
        calculateNextChange();
    }, [calculateNextChange]);

    const [localBusinessInfo, setLocalBusinessInfo] = useState({
        businessname: '',
        businessaddress: '',
        phonenumber: '',
        gst_number: '',
        email: '',
        bussinesslogo: '',
        bussinesslogo_url: ''
    });

    const fetchBusinessInfo = useCallback(async () => {
        if (!user || !user.username) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/root_users.php?action=get_business_info&username=' + encodeURIComponent(user.username), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                credentials: 'include'
            });
            const data = await response.json();
            if (data.status === 'success') {
                setLocalBusinessInfo({
                    businessname: data.businessname || '',
                    businessaddress: data.businessaddress || '',
                    phonenumber: data.phonenumber || '',
                    gst_number: data.gst_number || '',
                    email: data.email || '',
                    bussinesslogo: data.bussinesslogo || '',
                    bussinesslogo_url: data.bussinesslogo_url || ''
                });
            } else {
                setLocalBusinessInfo({
                    businessname: user.business_name || user.fullname || '',
                    businessaddress: user.business_address || '',
                    phonenumber: user.phonenumber || '',
                    gst_number: user.gst_number || '',
                    email: user.email || '',
                    bussinesslogo: user.bussinesslogo || '',
                    bussinesslogo_url: user.bussinesslogo_url || ''
                });
            }
        } catch (error) {
            console.error('Error fetching business info:', error);
            setLocalBusinessInfo({
                businessname: user.business_name || user.fullname || '',
                businessaddress: user.business_address || '',
                phonenumber: user.phonenumber || '',
                gst_number: user.gst_number || '',
                email: user.email || '',
                bussinesslogo: user.bussinesslogo || '',
                bussinesslogo_url: user.bussinesslogo_url || ''
            });
        }
    }, [user]);

    useEffect(() => {
        fetchBusinessInfo();
    }, [fetchBusinessInfo]);

    const escapeHtml = (text) => {
        if (!text) return '';
        return String(text)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    };

    const formatCurrency = (amount) => {
        if (!amount && amount !== 0) return 'Rs. 0.00';
        return `Rs. ${parseFloat(amount).toFixed(2)}`;
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    const formatTime = () => {
        return new Date().toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });
    };

    const handlePrintBarcode = async () => {
        const qrData = [
            `AGHA GUL AUTOMOTIVES, QUETTA`,
            `Date: ${formData.date || 'N/A'}`,
            `Customer: ${selectedCustomer?.customer_name || 'Walking Customer'}`,
            `Car Type: ${formData.car_model || 'N/A'}`,
            `Number Plate: ${formData.car_number_plate || 'N/A'}`,
            `Current Meter Reading: ${formData.odometer_reading || 'N/A'} km`,
            `Next Change: ${nextChange || 'N/A'} km`,
            `Products: ${selectedProducts.length > 0 ? selectedProducts.map(p => `${p.product_name} x${p.quantity} ${p.unit_of_measure}`).join(', ') : 'None'}`,
        ].join('\n');

        try {
            const qrDataUrl = await QRCode.toDataURL(qrData, {
                width: 600,
                margin: 0,
                errorCorrectionLevel: 'M',
                color: { dark: '#000000', light: '#FFFFFF' }
            });

            const printWindow = window.open('', '_blank', 'width=300,height=200');
            if (!printWindow) {
                showToast('error', 'Please allow pop-ups to print QR code');
                return;
            }

            printWindow.document.open();
            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>QR</title>
                    <style>
                        @page { size: 50mm 25mm; margin: 0; }
                        * { margin: 0 !important; padding: 0 !important; box-sizing: border-box; }
                        html, body {
                            width: 50mm;
                            height: 25mm;
                            overflow: hidden;
                        }
                        .qr-wrap {
                            width: 50mm;
                            height: 25mm;
                            overflow: hidden;
                            position: relative;
                        }
                        .qr-wrap img {
                            display: block;
                            position: absolute;
                            top: 0.5mm; left: 12.5mm;
                            width: 24mm;
                            height: 24mm;
                        }
                    </style>
                </head>
                <body>
                    <div class="qr-wrap"><img id="qrImg" src="${qrDataUrl}" /></div>
                </body>
                </html>
            `);
            printWindow.document.close();

            const img = printWindow.document.getElementById('qrImg');
            const triggerPrint = () => {
                printWindow.focus();
                printWindow.print();
            };

            if (img.complete) {
                triggerPrint();
            } else {
                img.onload = triggerPrint;
            }

            printWindow.onafterprint = () => printWindow.close();
        } catch (error) {
            console.error('Error generating QR code:', error);
            showToast('error', 'Failed to generate QR code');
        }
    };

    const handlePrintReceipt = () => {
        const printWindow = window.open('', '_blank');

        if (printWindow) {
            const shopName = localBusinessInfo?.businessname || currentShop?.shop_name || 'Oil Change Shop';
            const shopAddress = localBusinessInfo?.businessaddress || '';
            const shopPhone = localBusinessInfo?.phonenumber || '';
            const businessEmail = localBusinessInfo?.email || '';
            const gstNumber = localBusinessInfo?.gst_number || '';
            const businessLogo = localBusinessInfo?.bussinesslogo_url || localBusinessInfo?.bussinesslogo || '';

            const formatCurrency = (amount) => {
                if (!amount && amount !== 0) return 'Rs. 0.00';
                return `Rs. ${parseFloat(amount).toFixed(2)}`;
            };

            const formatDate = (dateString) => {
                if (!dateString) return '';
                const date = new Date(dateString);
                return date.toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' });
            };

            const productsTotal = selectedProducts.reduce((sum, p) => sum + ((Number(p.price_per_unit) || 0) * (Number(p.quantity) || 0)), 0);
            const subtotal = productsTotal;
            const discount = Number(formData.discount) || 0;
            const tax = Number(formData.tax) || 0;
            const grandTotal = subtotal - discount + tax;
            const paidAmount = Number(formData.paid_amount) || 0;
            const balance = grandTotal - paidAmount;

            const customerName = selectedCustomer?.customer_name || 'Walk-in Customer';
            const customerPhone = selectedCustomer?.phone || '';
            const customerAddress = selectedCustomer?.address || '';

            const themeColor = currentThemeColor || '#6366f1';

            const escapeHtml = (text) => {
                if (!text) return '';
                return String(text).replace(/[&<>]/g, function(m) {
                    if (m === '&') return '&amp;';
                    if (m === '<') return '&lt;';
                    if (m === '>') return '&gt;';
                    return m;
                });
            };

            const getOilTypeLabel = (value) => {
                const oilTypes = {
                    'engine_oil': 'Engine Oil',
                    'gear_oil': 'Gear Oil',
                    'brake_fluid': 'Brake Fluid',
                    'coolant': 'Coolant',
                    'power_steering': 'Power Steering',
                    'transmission_fluid': 'Transmission Fluid'
                };
                return oilTypes[value] || value || '';
            };

            const getFilterTypeLabel = (value) => {
                const filterTypes = {
                    'oil_filter': 'Oil Filter',
                    'air_filter': 'Air Filter',
                    'fuel_filter': 'Fuel Filter',
                    'cabin_filter': 'Cabin Filter'
                };
                return filterTypes[value] || value || '';
            };

            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Oil Change Receipt ${formData.oil_number}</title>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <style>
                        @page { size: auto; margin: 12mm; }
                        * { margin: 0; padding: 0; box-sizing: border-box; }
                        body {
                            font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
                            background: white;
                            color: #1f2937;
                            font-size: 10pt;
                            line-height: 1.4;
                        }
                        .receipt-container { max-width: 100%; margin: 0 auto; padding: 0; }
                        .text-center { text-align: center; }
                        .text-right { text-align: right; }
                        .text-left { text-align: left; }
                        .font-bold { font-weight: bold; }
                        .header {
                            display: flex;
                            align-items: flex-start;
                            justify-content: space-between;
                            padding-bottom: 12px;
                            border-bottom: 2px solid #e5e7eb;
                            margin-bottom: 15px;
                        }
                        .header-left {
                            display: flex;
                            align-items: center;
                            gap: 15px;
                            flex: 1;
                        }
                        .header-logo-wrapper { flex-shrink: 0; }
                        .header-logo {
                            max-height: 70px;
                            max-width: 100px;
                            width: auto;
                            height: auto;
                            object-fit: contain;
                            display: block;
                        }
                        .header-info { flex: 1; min-width: 0; }
                        .business-name {
                            font-size: 18pt;
                            font-weight: 700;
                            color: #1f2937;
                            letter-spacing: 0.5px;
                            word-break: break-word;
                            line-height: 1.2;
                        }
                        .business-address {
                            font-size: 9pt;
                            color: #6b7280;
                            margin-top: 2px;
                            word-break: break-word;
                            line-height: 1.4;
                        }
                        .business-contact {
                            display: flex;
                            align-items: center;
                            gap: 15px;
                            flex-wrap: wrap;
                            margin-top: 2px;
                            font-size: 9pt;
                            color: #6b7280;
                        }
                        .business-gst {
                            font-size: 8pt;
                            color: #9ca3af;
                            margin-top: 1px;
                        }
                        .header-right {
                            text-align: right;
                            flex-shrink: 0;
                            margin-left: 20px;
                        }
                        .header-right .receipt-label {
                            font-size: 16pt;
                            font-weight: 700;
                            text-transform: uppercase;
                            letter-spacing: 3px;
                            color: #1f2937;
                        }
                        .header-right .customer-info-label {
                            font-size: 10pt;
                            color: #4b5563;
                            margin-top: 4px;
                            font-weight: 500;
                        }
                        .header-right .customer-info-label span {
                            font-weight: 600;
                            color: #1f2937;
                        }
                        .bill-info {
                            display: flex;
                            justify-content: space-between;
                            font-size: 10pt;
                            margin: 4px 0;
                            padding: 3px 0;
                            flex-wrap: wrap;
                            gap: 5px;
                        }
                        .bill-info .label { font-weight: 600; color: #4b5563; }
                        .bill-info .value { font-weight: 500; }
                        .customer-info {
                            margin: 10px 0;
                            padding: 8px 12px;
                            background: #f9fafb;
                            border-radius: 6px;
                            font-size: 10pt;
                            border-left: 4px solid ${themeColor};
                        }
                        .customer-info .customer-name { font-weight: 600; font-size: 11pt; }
                        .customer-info .customer-phone { color: #4b5563; margin-top: 2px; }
                        .customer-info .customer-address { color: #6b7280; font-size: 9pt; margin-top: 2px; word-break: break-word; }
                        .customer-info .car-details { 
                            margin-top: 4px; 
                            padding-top: 4px; 
                            border-top: 1px dashed #e5e7eb;
                            font-size: 9pt;
                            color: #4b5563;
                        }
                        .customer-info .car-details .car-label { font-weight: 600; color: #1f2937; }
                        .items-table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 12px 0;
                            border: 1px solid #d1d5db;
                        }
                        .items-table th {
                            background: #f3f4f6;
                            text-align: left;
                            padding: 10px 8px;
                            font-size: 9pt;
                            font-weight: 600;
                            text-transform: uppercase;
                            letter-spacing: 0.5px;
                            color: #374151;
                            border: 1px solid #d1d5db;
                        }
                        .items-table td {
                            padding: 8px 8px;
                            font-size: 10pt;
                            vertical-align: top;
                            border: 1px solid #d1d5db;
                        }
                        .items-table th:last-child,
                        .items-table td:last-child { text-align: right; }
                        .items-table th:nth-child(3),
                        .items-table td:nth-child(3) { text-align: center; }
                        .items-table th:nth-child(1),
                        .items-table td:nth-child(1) { text-align: center; }
                        .items-table .product-name { font-weight: 500; word-break: break-word; }
                        .items-table .product-meta { font-size: 8pt; color: #9ca3af; display: block; }
                        .oil-details-table td:last-child { text-align: right; }
                        .oil-details-table .oil-label-cell { font-weight: 500; }
                        .payment-section {
                            display: flex;
                            justify-content: flex-end;
                            margin-top: 10px;
                            padding-top: 5px;
                            border-top: 1px solid #e5e7eb;
                        }
                        .payment-box { width: 280px; }
                        .payment-row {
                            display: flex;
                            justify-content: space-between;
                            padding: 4px 0;
                            font-size: 10.5pt;
                        }
                        .payment-row .label { color: #4b5563; font-weight: 500; }
                        .payment-row .value { font-weight: 500; }
                        .payment-row.total {
                            font-weight: 700;
                            font-size: 13pt;
                            padding-top: 8px;
                            border-top: 2px solid #1f2937;
                            margin-top: 4px;
                        }
                        .payment-row.total .label { color: #1f2937; }
                        .payment-row.total .value { color: #059669; }
                        .payment-row .value.text-danger { color: #dc2626; }
                        .payment-row .value.text-primary { color: #3b82f6; }
                        .payment-row .value.text-warning { color: #d97706; }
                        .payment-row .value.text-success { color: #059669; }
                        .payment-method-box {
                            display: flex;
                            justify-content: flex-end;
                            margin-top: 6px;
                            gap: 12px;
                            font-size: 9pt;
                            color: #6b7280;
                        }
                        .payment-method-box .badge {
                            display: inline-block;
                            background: #f3f4f6;
                            padding: 3px 12px;
                            border-radius: 4px;
                            font-weight: 600;
                            font-size: 9pt;
                            color: #374151;
                        }
                        .footer {
                            text-align: center;
                            font-size: 8pt;
                            margin-top: 15px;
                            padding-top: 10px;
                            border-top: 1px solid #e5e7eb;
                            color: #9ca3af;
                        }
                        .footer .thankyou { font-size: 11pt; color: #4b5563; font-weight: 500; }
                        .notes-box {
                            background: #f9fafb;
                            padding: 8px 12px;
                            border-radius: 6px;
                            font-size: 9pt;
                            color: #4b5563;
                            margin-top: 10px;
                            border-left: 4px solid #9ca3af;
                            word-break: break-word;
                        }
                        @media print { body { margin: 0; } .no-print { display: none; } }
                        @media print and (max-width: 160mm) {
                            body { font-size: 9pt; }
                            .business-name { font-size: 14pt; }
                            .header-right .receipt-label { font-size: 13pt; }
                            .items-table th, .items-table td { font-size: 8.5pt; padding: 6px 6px; }
                            .payment-box { width: 230px; }
                            .payment-row { font-size: 9pt; }
                            .payment-row.total { font-size: 11pt; }
                            .header-logo { max-height: 50px; max-width: 80px; }
                        }
                    </style>
                </head>
                <body>
                    <div class="receipt-container">
                        <div class="header">
                            <div class="header-left">
                                ${businessLogo ? `
                                <div class="header-logo-wrapper">
                                    <img src="${businessLogo}" alt="${escapeHtml(shopName)}" class="header-logo" onerror="this.style.display='none'" />
                                </div>` : ''}
                                <div class="header-info">
                                    <div class="business-name">${escapeHtml(shopName)}</div>
                                    ${shopAddress ? `<div class="business-address">${escapeHtml(shopAddress)}</div>` : ''}
                                    ${(shopPhone || businessEmail) ? `
                                    <div class="business-contact">
                                        ${shopPhone ? `<span>📞 ${escapeHtml(shopPhone)}</span>` : ''}
                                        ${businessEmail ? `<span>✉ ${escapeHtml(businessEmail)}</span>` : ''}
                                    </div>` : ''}
                                    ${gstNumber ? `<div class="business-gst">GST: ${escapeHtml(gstNumber)}</div>` : ''}
                                </div>
                            </div>
                            <div class="header-right">
                                <div class="receipt-label">${translations.receipt || 'OIL CHANGE RECEIPT'}</div>
                                <div class="customer-info-label">${translations.customer || 'Customer'}: <span>${escapeHtml(customerName)}</span></div>
                            </div>
                        </div>
                        
                        <div class="bill-info">
                            <span><span class="label">${translations.date || 'Date'}:</span> <span class="value">${formatDate(formData.date)}</span></span>
                            <span><span class="label">${translations.carModel || 'Car Model'}:</span> <span class="value">${escapeHtml(formData.car_model || '—')}</span></span>
                            <span><span class="label">${translations.numberPlate || 'Number Plate'}:</span> <span class="value">${escapeHtml(formData.car_number_plate || '—')}</span></span>
                        </div>
                        
                        ${(oilDetails.oil_type || oilDetails.oil_quantity || oilDetails.filter_type || oilDetails.oil_brand) ? `
                        <table class="items-table oil-details-table">
                            <thead>
                                <tr>
                                    <th style="width:50%;">${translations.oilDetails || 'Oil Details'}</th>
                                    <th style="width:50%;">${translations.value || 'Value'}</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${oilDetails.oil_type ? `
                                <tr>
                                    <td class="oil-label-cell">${translations.oilType || 'Oil Type'}</td>
                                    <td>${escapeHtml(getOilTypeLabel(oilDetails.oil_type))}</td>
                                </tr>` : ''}
                                ${oilDetails.oil_brand ? `
                                <tr>
                                    <td class="oil-label-cell">${translations.oilBrand || 'Oil Brand'}</td>
                                    <td>${escapeHtml(oilDetails.oil_brand)}</td>
                                </tr>` : ''}
                                ${oilDetails.oil_quantity ? `
                                <tr>
                                    <td class="oil-label-cell">${translations.oilQuantity || 'Oil Quantity'}</td>
                                    <td>${escapeHtml(oilDetails.oil_quantity)} Ltr</td>
                                </tr>` : ''}
                                ${oilDetails.filter_type ? `
                                <tr>
                                    <td class="oil-label-cell">${translations.filterType || 'Filter Type'}</td>
                                    <td>${escapeHtml(getFilterTypeLabel(oilDetails.filter_type))}</td>
                                </tr>` : ''}
                                ${moboOilMillage ? `
                                <tr>
                                    <td class="oil-label-cell">${translations.moboOilMillage || 'Mobo Oil Millage'}</td>
                                    <td>${escapeHtml(moboOilMillage)} km</td>
                                </tr>` : ''}
                                ${nextChange ? `
                                <tr>
                                    <td class="oil-label-cell">${translations.nextChange || 'Next Change'}</td>
                                    <td>${escapeHtml(nextChange)} km</td>
                                </tr>` : ''}
                                ${formData.odometer_reading ? `
                                <tr>
                                    <td class="oil-label-cell">${translations.meterReading || 'Meter Reading'}</td>
                                    <td>${escapeHtml(formData.odometer_reading)} km</td>
                                </tr>` : ''}
                            </tbody>
                        </table>
                        ` : ''}
                        
                        ${selectedProducts.length > 0 ? `
                        <table class="items-table">
                            <thead>
                                <tr>
                                    <th style="width:8%;">#</th>
                                    <th style="width:37%;">${translations.productName || 'Product'}</th>
                                    <th style="width:15%;">${translations.quantity || 'Qty'}</th>
                                    <th style="width:18%;">${translations.price || 'Price'}</th>
                                    <th style="width:22%;">${translations.total || 'Total'}</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${selectedProducts.map((product, idx) => `
                                <tr>
                                    <td>${idx + 1}</td>
                                    <td>
                                        <div class="product-name">${escapeHtml(product.product_name)}</div>
                                        ${product.product_code ? `<div class="product-meta">Code: ${escapeHtml(product.product_code)}</div>` : ''}
                                    </td>
                                    <td>${parseFloat(product.quantity).toFixed(2)} ${product.unit || ''}</td>
                                    <td>${formatCurrency(product.price_per_unit)}</td>
                                    <td>${formatCurrency(product.price_per_unit * product.quantity)}</td>
                                </tr>
                                `).join('')}
                            </tbody>
                        </table>
                        ` : ''}
                        
                        <div class="payment-section">
                            <div class="payment-box">
                                ${selectedProducts.length > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.productsTotal || 'Products Total'}</span>
                                    <span class="value">${formatCurrency(productsTotal)}</span>
                                </div>` : ''}
                                <div class="payment-row">
                                    <span class="label">${translations.subtotal || 'Subtotal'}</span>
                                    <span class="value">${formatCurrency(subtotal)}</span>
                                </div>
                                ${discount > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.discount || 'Discount'}</span>
                                    <span class="value text-danger">-${formatCurrency(discount)}</span>
                                </div>` : ''}
                                ${tax > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.tax || 'Tax'}</span>
                                    <span class="value">${formatCurrency(tax)}</span>
                                </div>` : ''}
                                <div class="payment-row total">
                                    <span class="label">${translations.grandTotal || 'GRAND TOTAL'}</span>
                                    <span class="value">${formatCurrency(grandTotal)}</span>
                                </div>
                                ${paidAmount > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.paidAmount || 'Paid'}</span>
                                    <span class="value text-primary">${formatCurrency(paidAmount)}</span>
                                </div>` : ''}
                                ${balance > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.balance || 'Balance Due'}</span>
                                    <span class="value text-warning">${formatCurrency(balance)}</span>
                                </div>` : ''}
                                ${balance <= 0 && paidAmount > 0 ? `
                                <div class="payment-row">
                                    <span class="label">${translations.balance || 'Balance'}</span>
                                    <span class="value text-success">${formatCurrency(balance)}</span>
                                </div>` : ''}
                            </div>
                        </div>
                    </div>
                    <script>
                    window.onload = function() {
                        setTimeout(function() {
                            window.print();
                            window.onafterprint = function() { window.close(); };
                        }, 500);
                    };
                    <\/script>
                </body>
                </html>
            `);

            printWindow.document.close();
            printWindow.focus();
        }
    };

    const saveDraft = () => {
        const draftData = {
            formData,
            selectedProducts,
            selectedCustomer,
            customerSearchTerm,
            manualPhoneNumber,
            oilDetails,
            moboOilMillage,
            nextChange,
            savedAt: new Date().toISOString(),
            shop_id: currentShop?.shop_id
        };

        if (!formData.oil_number && selectedProducts.length === 0 && !oilDetails.oil_type) {
            showToast('warning', translations.cannotSaveEmpty || 'Cannot save empty draft');
            return;
        }

        const draftId = Date.now();
        const draft = {
            id: draftId,
            ...draftData,
            savedAt: new Date().toISOString(),
            shop_id: currentShop?.shop_id
        };

        const existingDrafts = JSON.parse(localStorage.getItem('oil_drafts') || '[]');
        existingDrafts.unshift(draft);
        const limitedDrafts = existingDrafts.slice(0, 20);
        localStorage.setItem('oil_drafts', JSON.stringify(limitedDrafts));

        showToast('success', translations.draftSaved || 'Draft saved successfully!');
        loadDrafts();
    };

    const loadDrafts = () => {
        const drafts = JSON.parse(localStorage.getItem('oil_drafts') || '[]');
        const filteredDrafts = currentShop ? drafts.filter(d => d.shop_id === currentShop?.shop_id) : drafts;
        setSavedDrafts(filteredDrafts);
    };

    const loadDraft = (draft) => {
        setFormData(draft.formData || {
            date: new Date().toISOString().split('T')[0],
            oil_number: '',
            car_model: '',
            car_number_plate: '',
            car_color: '',
            car_year: '',
            odometer_reading: '',
            vehicle_type: '',
            subtotal: 0,
            tax: 0,
            discount: 0,
            grand_total: 0,
            paid_amount: 0,
            balance: 0,
            payment_method: 'cash',
            status: 'completed',
            notes: ''
        });
        setSelectedProducts(draft.selectedProducts || []);
        setSelectedCustomer(draft.selectedCustomer || null);
        setCustomerSearchTerm(draft.customerSearchTerm || '');
        setManualPhoneNumber(draft.manualPhoneNumber || '');
        setOilDetails(draft.oilDetails || { oil_type: '', oil_quantity: '', filter_type: '', oil_brand: '' });
        setMoboOilMillage(draft.moboOilMillage || '');
        setNextChange(draft.nextChange || '');
        setShowDraftsList(false);
        showToast('success', translations.draftLoaded || 'Draft loaded successfully!');
    };

    const deleteDraft = (draftId) => {
        const drafts = JSON.parse(localStorage.getItem('oil_drafts') || '[]');
        const filteredDrafts = drafts.filter(d => d.id !== draftId);
        localStorage.setItem('oil_drafts', JSON.stringify(filteredDrafts));
        loadDrafts();
        showToast('success', translations.draftDeleted || 'Draft deleted successfully!');
    };

    useEffect(() => {
        loadDrafts();
    }, [currentShop]);

    useEffect(() => {
        if (showDraftsList && draftsDropdownRef.current) {
            const button = draftsDropdownRef.current.querySelector('.drafts-btn');
            const dropdown = draftsDropdownRef.current.querySelector('.ozui-drafts-dropdown');

            if (button && dropdown) {
                const rect = button.getBoundingClientRect();
                dropdown.style.position = 'fixed';
                dropdown.style.top = `${rect.bottom + 8}px`;
                dropdown.style.right = `${window.innerWidth - rect.right}px`;
            }
        }
    }, [showDraftsList]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (draftsDropdownRef.current && !draftsDropdownRef.current.contains(event.target)) {
                setShowDraftsList(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (paymentMethodRef.current && !paymentMethodRef.current.contains(event.target)) {
                setShowPaymentMethodDropdown(false);
            }
            if (statusRef.current && !statusRef.current.contains(event.target)) {
                setShowStatusDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const applyTheme = useCallback((color) => {
        if (!color || !/^#[0-9A-F]{6}$/i.test(color)) color = '#6366f1';
        let r, g, b;
        if (color.startsWith('#')) {
            r = parseInt(color.slice(1, 3), 16);
            g = parseInt(color.slice(3, 5), 16);
            b = parseInt(color.slice(5, 7), 16);
        } else {
            r = 99; g = 102; b = 241;
        }

        document.documentElement.style.setProperty('--ozserui-primary', color);
        document.documentElement.style.setProperty('--ozserui-primary-dark', color);
        document.documentElement.style.setProperty('--ozserui-primary-light', color);

        let style = document.getElementById('dynamic-orb-styles-oil');
        if (!style) {
            style = document.createElement('style');
            style.id = 'dynamic-orb-styles-oil';
            document.head.appendChild(style);
        }

        style.textContent = `
            .ozserui-header-bg-animation .ozserui-gradient-orb.ozserui-orb-1 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.4) 0%, rgba(${r}, ${g}, ${b}, 0.1) 100%);
            }
            .ozserui-header-bg-animation .ozserui-gradient-orb.ozserui-orb-2 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.35) 0%, rgba(${r}, ${g}, ${b}, 0.08) 100%);
            }
            .ozserui-header-bg-animation .ozserui-gradient-orb.ozserui-orb-3 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.3) 0%, rgba(${r}, ${g}, ${b}, 0.05) 100%);
            }
            .ozserui-header-bg-animation .ozserui-gradient-orb.ozserui-orb-4 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.25) 0%, rgba(${r}, ${g}, ${b}, 0.03) 100%);
            }
            .ozserui-header-bg-animation .ozserui-gradient-orb.ozserui-orb-5 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.2) 0%, rgba(${r}, ${g}, ${b}, 0.02) 100%);
            }
        `;

        setCurrentThemeColor(color);
    }, []);

    useEffect(() => {
        const savedTheme = localStorage.getItem('ourzest_theme') || '#6366f1';
        applyTheme(savedTheme);

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                applyTheme(e.newValue || '#6366f1');
            }
        };

        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
        };
    }, [applyTheme]);

    useEffect(() => {
        const syncDarkMode = () => {
            const isDark = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDark);
            const container = document.querySelector('.ozserui-container');
            if (container) {
                if (isDark) {
                    container.classList.add('ozserui-dark');
                } else {
                    container.classList.remove('ozserui-dark');
                }
            }

            if (isDark) {
                document.body.classList.add('ozserui-dark');
                document.documentElement.classList.add('ozserui-dark');
            } else {
                document.body.classList.remove('ozserui-dark');
                document.documentElement.classList.remove('ozserui-dark');
            }
        };

        syncDarkMode();

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') syncDarkMode();
        };

        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);
                const container = document.querySelector('.ozserui-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('ozserui-dark');
                    } else {
                        container.classList.remove('ozserui-dark');
                    }
                }
                if (isDark) {
                    document.body.classList.add('ozserui-dark');
                    document.documentElement.classList.add('ozserui-dark');
                } else {
                    document.body.classList.remove('ozserui-dark');
                    document.documentElement.classList.remove('ozserui-dark');
                }
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
        };
    }, []);

    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await oilTranslator.getTranslations(lang);
            setTranslations(trans);
        };

        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };

        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };

        loadTranslations(currentLanguage);

        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);

        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
        };
    }, [currentLanguage]);

    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.ozserui-container');

        if (container) {
            if (isRTL) {
                container.classList.add('ozserui-rtl');
                container.classList.remove('ozserui-ltr');
            } else {
                container.classList.add('ozserui-ltr');
                container.classList.remove('ozserui-rtl');
            }
        }

        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    const showToast = (type, message) => {
        setToast({ show: true, type, message });
        setTimeout(() => setToast(prev => ({ ...prev, show: false })), 3000);
    };

    const loadEmployees = async () => {
        if (!shopId) return;
        try {
            const response = await fetch(EMPLOYEE_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_records', shop_id: shopId, status: 'active' })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setEmployees(data.data || []);
            }
        } catch (error) {
            console.error('Error loading employees:', error);
        }
    };

    const searchCustomers = async (searchTerm) => {
        if (!shopId) return;
        setSearchingCustomer(true);
        try {
            const response = await fetch(OIL_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'search_customers', shop_id: shopId, search_term: searchTerm })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setCustomers(data.data || []);
                setShowCustomerDropdown(data.data.length > 0);
            }
        } catch (error) {
            console.error('Error searching customers:', error);
        } finally {
            setSearchingCustomer(false);
        }
    };

    const searchProducts = async (searchTerm) => {
        if (!shopId || searchTerm.length < 2) {
            setProducts([]);
            setShowProductDropdown(false);
            return;
        }
        setSearchingProduct(true);
        try {
            const response = await fetch(OIL_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'search_products', shop_id: shopId, search_term: searchTerm })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setProducts(data.data || []);
                setShowProductDropdown(data.data.length > 0);
            }
        } catch (error) {
            console.error('Error searching products:', error);
        } finally {
            setSearchingProduct(false);
        }
    };

    const selectCustomer = (customer) => {
        setSelectedCustomer(customer);
        setCustomerSearchTerm(customer.customer_name);
        setManualPhoneNumber(customer.phone || '');
        setShowCustomerDropdown(false);
    };

    const selectProduct = (product) => {
        const existingIndex = selectedProducts.findIndex(p => p.product_id === product.id);
        const pricePerUnit = Number(product.sell_price_per_unit || product.sell_price) || 0;

        if (existingIndex >= 0) {
            const updated = selectedProducts.map((p, i) =>
                i === existingIndex ? { ...p, quantity: (p.quantity || 0) + 1 } : p
            );
            setSelectedProducts(updated);
        } else {
            setSelectedProducts([
                ...selectedProducts,
                {
                    product_id: product.id,
                    product_name: product.product_name,
                    product_code: product.product_code,
                    batch_no: product.batch_no,
                    quantity: 1,
                    unit: product.sub_packing_type || product.unit_of_measure || 'piece',
                    unit_of_measure: product.unit_of_measure,
                    packing_type: product.packing_type,
                    items_per_pack: product.items_per_pack || 1,
                    price_per_unit: pricePerUnit
                }
            ]);
        }
        setProductSearchTerm('');
        setShowProductDropdown(false);
        showToast('success', `${product.product_name} added to products used`);
    };

    const updateProductQuantity = (index, quantity) => {
        setSelectedProducts(prev =>
            prev.map((p, i) =>
                i === index ? { ...p, quantity: quantity } : p
            )
        );
    };

    const removeProduct = (index) => {
        setSelectedProducts(prev => prev.filter((_, i) => i !== index));
    };

    const calculateTaskBasedEmployeeTotal = () => {
        let total = 0;
        return total;
    };

    const calculateTotals = useCallback(() => {
        const productsTotal = selectedProducts.reduce(
            (sum, p) => sum + ((Number(p.price_per_unit) || 0) * (Number(p.quantity) || 0)),
            0
        );
        const subtotal = productsTotal;
        const tax = Number(formData.tax) || 0;
        const discount = Number(formData.discount) || 0;
        const grandTotal = subtotal + tax - discount;
        const paid = Number(formData.paid_amount) || 0;
        const balance = grandTotal - paid;

        setFormData(prev => ({ ...prev, subtotal, grand_total: grandTotal, balance }));
    }, [selectedProducts, formData.tax, formData.discount, formData.paid_amount]);

    useEffect(() => {
        calculateTotals();
    }, [selectedProducts, formData.tax, formData.discount, calculateTotals]);

    const loadOilData = async (id) => {
        if (!shopId) return;
        setLoading(true);
        try {
            const response = await fetch(OIL_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_record', mobchange_id: id, shop_id: shopId })
            });
            const data = await response.json();
            if (data.status === 'success') {
                const oil = data.data;
                setFormData(prev => ({
                    ...prev,
                    date: oil.date || new Date().toISOString().split('T')[0],
                    oil_number: oil.mobchange_number || '',
                    car_model: oil.car_model || '',
                    car_number_plate: oil.car_number_plate || '',
                    car_color: oil.car_color || '',
                    car_year: oil.car_year || '',
                    odometer_reading: oil.odometer_reading || '',
                    vehicle_type: oil.vehicle_type || '',
                    subtotal: parseFloat(oil.subtotal) || 0,
                    tax: parseFloat(oil.tax) || 0,
                    discount: parseFloat(oil.discount) || 0,
                    grand_total: parseFloat(oil.grand_total) || 0,
                    paid_amount: parseFloat(oil.paid_amount) || 0,
                    balance: parseFloat(oil.balance) || 0,
                    payment_method: oil.payment_method || 'cash',
                    status: oil.status || 'completed',
                    notes: oil.notes || ''
                }));

                if (oil.oil_type) {
                    setOilDetails({
                        oil_type: oil.oil_type || '',
                        oil_quantity: oil.oil_quantity || '',
                        filter_type: oil.filter_type || '',
                        oil_brand: oil.oil_brand || ''
                    });
                }

                if (oil.customer_id && oil.customer_name) {
                    setSelectedCustomer({
                        customerid: oil.customer_id,
                        customer_name: oil.customer_name,
                        phone: oil.customer_phone || '',
                        address: oil.customer_address || ''
                    });
                    setCustomerSearchTerm(oil.customer_name);
                    setManualPhoneNumber(oil.customer_phone || '');
                } else if (oil.is_walking_customer) {
                    setCustomerSearchTerm('Walking Customer');
                    setManualPhoneNumber('');
                }

                if (oil.products && oil.products.length > 0) {
                    setSelectedProducts(oil.products.map(p => ({
                        product_id: p.product_id,
                        product_name: p.product_name,
                        product_code: p.product_code,
                        batch_no: p.batch_no,
                        quantity: parseFloat(p.quantity),
                        unit: p.unit,
                        unit_of_measure: p.unit_of_measure,
                        packing_type: p.packing_type,
                        items_per_pack: p.items_per_pack || 1,
                        price_per_unit: parseFloat(p.price_per_unit) || 0
                    })));
                }
            }
        } catch (error) {
            console.error('Error loading oil data:', error);
            showToast('error', 'Failed to load oil change data');
        } finally {
            setLoading(false);
        }
    };

    const getNextOilNumber = async () => {
        if (!shopId) return;
        try {
            const response = await fetch(OIL_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_next_number', shop_id: shopId })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setFormData(prev => ({ ...prev, oil_number: data.data.mobchange_number }));
            }
        } catch (error) {
            console.error('Error getting oil number:', error);
        }
    };

    useEffect(() => {
        if (currentShop?.shop_id) {
            setShopId(currentShop.shop_id);
        }
    }, [currentShop]);

    useEffect(() => {
        if (shopId) {
            loadEmployees();
            if (!isEditMode) getNextOilNumber();
        }
    }, [shopId, isEditMode]);

    useEffect(() => {
        if (oilId) {
            setIsEditMode(true);
            loadOilData(oilId);
        }
    }, [oilId]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (customerSearchRef.current && !customerSearchRef.current.contains(event.target)) setShowCustomerDropdown(false);
            if (productSearchRef.current && !productSearchRef.current.contains(event.target)) setShowProductDropdown(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const loadAvailableShops = async () => {
            if (!user) return;
            setLoadingShops(true);
            try {
                const shopsData = await getShopsForSwitch();
                setAvailableShops(shopsData.shops || []);
            } catch (error) {
                setAvailableShops([]);
            } finally {
                setLoadingShops(false);
            }
        };
        loadAvailableShops();
    }, [user, getShopsForSwitch]);

    const handleSwitchShop = async (shop) => {
        try {
            const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
            if (success) {
                showToast('success', translations.shopSwitched || 'Shop switched successfully');
                setShowShopSelector(false);
            } else {
                showToast('error', translations.shopSwitchFailed || 'Failed to switch shop');
            }
        } catch (error) {
            showToast('error', translations.shopSwitchFailed || 'Failed to switch shop');
        }
    };

    const handleClear = () => {
        if (isEditMode) return;
        setFormData({
            date: new Date().toISOString().split('T')[0],
            oil_number: formData.oil_number,
            car_model: '',
            car_number_plate: '',
            car_color: '',
            car_year: '',
            odometer_reading: '',
            vehicle_type: '',
            subtotal: 0,
            tax: 0,
            discount: 0,
            grand_total: 0,
            paid_amount: 0,
            balance: 0,
            payment_method: 'cash',
            status: 'pending',
            notes: '',
            themeColor: localStorage.getItem('ourzest_theme') || '#6366f1'
        });
        setSelectedProducts([]);
        setSelectedCustomer(null);
        setCustomerSearchTerm('');
        setManualPhoneNumber('');
        setOilDetails({
            oil_type: '',
            oil_quantity: '',
            filter_type: '',
            oil_brand: ''
        });
        setMoboOilMillage('');
        setNextChange('');
        setErrors({});
        showToast('success', translations.clearForm || 'Form cleared');
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleCarModelChange = (value) => {
        setFormData(prev => ({ ...prev, car_model: value }));
    };

    const handleOilDetailChange = (e) => {
        const { name, value } = e.target;
        setOilDetails(prev => ({ ...prev, [name]: value }));
    };

    const handleMoboOilMillageChange = (e) => {
        const value = e.target.value;
        setMoboOilMillage(value);
    };

    const handlePaymentMethodSelect = (value) => {
        setFormData(prev => ({ ...prev, payment_method: value }));
        setShowPaymentMethodDropdown(false);
    };

    const handleStatusSelect = (value) => {
        setFormData(prev => ({ ...prev, status: value }));
        setShowStatusDropdown(false);
    };

    const validateForm = () => {
        const newErrors = {};
        if (selectedProducts.length === 0 && !oilDetails.oil_type) {
            newErrors.products = 'At least one product or oil type is required';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSavingRef.current) {
            showToast('warning', translations.pleaseWait || 'Please wait, already processing...');
            return;
        }
        if (!currentShop) {
            showToast('error', translations.selectShopFirst || 'Please select a shop first');
            setShowShopSelector(true);
            return;
        }
        if (!validateForm()) {
            showToast('error', translations.fixErrors || 'Please fix the errors before submitting');
            return;
        }

        isSavingRef.current = true;
        setSaving(true);

        // FIXED: Properly construct the payload with customer data
        let customerPhone = '';
        let customerName = '';
        let customerId = null;

        if (selectedCustomer) {
            // Selected from dropdown
            customerId = selectedCustomer.customerid;
            customerName = selectedCustomer.customer_name;
            customerPhone = selectedCustomer.phone || manualPhoneNumber || '';
        } else if (customerSearchTerm === 'Walking Customer') {
            customerName = 'Walking Customer';
            customerPhone = '';
        } else if (customerSearchTerm) {
            // Manually typed customer name
            customerName = customerSearchTerm;
            customerPhone = manualPhoneNumber || '';
        }

        const payload = {
            action: isEditMode ? 'edit' : 'add',
            shop_id: currentShop?.shop_id || shopId,
            username: user?.username || '',
            date: formData.date,
            customer_id: customerId,
            customer_name: customerName,
            customer_phone: customerPhone,
            customer_address: selectedCustomer?.address || '',
            car_model: formData.car_model,
            car_number_plate: formData.car_number_plate,
            car_color: formData.car_color,
            car_year: formData.car_year,
            odometer_reading: formData.odometer_reading,
            vehicle_type: formData.vehicle_type,
            oil_type: oilDetails.oil_type,
            oil_quantity: oilDetails.oil_quantity,
            filter_type: oilDetails.filter_type,
            oil_brand: oilDetails.oil_brand,
            mobo_oil_millage: moboOilMillage,
            next_change: nextChange,
            products: selectedProducts.map(p => ({
                product_id: p.product_id,
                product_name: p.product_name,
                product_code: p.product_code,
                batch_no: p.batch_no,
                quantity: p.quantity,
                unit: p.unit,
                unit_of_measure: p.unit_of_measure,
                packing_type: p.packing_type,
                items_per_pack: p.items_per_pack,
                price_per_unit: p.price_per_unit
            })),
            subtotal: formData.subtotal,
            tax: formData.tax,
            discount: formData.discount,
            grand_total: formData.grand_total,
            paid_amount: formData.paid_amount,
            payment_method: formData.payment_method,
            status: formData.status,
            notes: formData.notes
        };

        if (isEditMode && oilId) payload.mobchange_id = oilId;

        console.log('Sending payload:', payload);

        try {
            const response = await fetch(OIL_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await response.json();

            if (data.status === 'success') {
                showToast('success', isEditMode ? translations.oilUpdated || 'Oil change updated successfully!' : translations.oilSaved || 'Oil change saved successfully!');
                if (!isEditMode) {
                    setSelectedProducts([]);
                    setSelectedCustomer(null);
                    setCustomerSearchTerm('');
                    setManualPhoneNumber('');
                    setOilDetails({
                        oil_type: '',
                        oil_quantity: '',
                        filter_type: '',
                        oil_brand: ''
                    });
                    setMoboOilMillage('');
                    setNextChange('');
                    setFormData(prev => ({
                        ...prev,
                        car_model: '',
                        car_number_plate: '',
                        car_color: '',
                        car_year: '',
                        odometer_reading: '',
                        vehicle_type: '',
                        tax: 0,
                        discount: 0,
                        paid_amount: 0,
                        payment_method: 'cash',
                        notes: ''
                    }));
                    getNextOilNumber();
                }
                if (onSuccess) onSuccess(data.data?.mobchange_id);
            } else {
                showToast('error', data.message || translations.failedSave || 'Failed to save oil change');
            }
        } catch (error) {
            console.error('Submit error:', error);
            showToast('error', translations.networkError || 'Network error occurred');
        } finally {
            isSavingRef.current = false;
            setSaving(false);
        }
    };

    const taskBasedTotal = calculateTaskBasedEmployeeTotal();
    const netReceivable = formData.grand_total - taskBasedTotal;
    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    return (
        <div className={`ozserui-container ${isRTL ? 'ozserui-rtl' : 'ozserui-ltr'} ${darkMode ? 'ozserui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
            />

            <PaymentModal
                showPaymentModal={showPaymentModal}
                setShowPaymentModal={setShowPaymentModal}
                translations={translations}
                selectedProducts={selectedProducts}
                formData={formData}
                taskBasedTotal={taskBasedTotal}
                netReceivable={netReceivable}
                handleChange={handleChange}
            />

            <div className="ozserui-sticky-header">
                <div className="ozserui-header-bg-animation">
                    <div className="ozserui-gradient-orb ozserui-orb-1"></div>
                    <div className="ozserui-gradient-orb ozserui-orb-2"></div>
                    <div className="ozserui-gradient-orb ozserui-orb-3"></div>
                    <div className="ozserui-gradient-orb ozserui-orb-4"></div>
                    <div className="ozserui-gradient-orb ozserui-orb-5"></div>
                </div>
                <div className="ozserui-header-content">
                    <div className="ozserui-header-left">
                        <div className="ozserui-header-title">
                            <h1>{isEditMode ? (translations.editOilChange || 'Edit Oil Change') : (translations.newOilChange || 'New Oil Change')}</h1>
                            <p>{isEditMode ? (translations.editDesc || 'Update oil change details') : (translations.createDesc || 'Create and manage oil change requests')}</p>
                        </div>
                    </div>

                    <div className="ozui-header-right">
                        {!currentShop && (
                            <button className="ozui-header-shop-btn" onClick={() => setShowShopSelector(true)}>
                                <FontAwesomeIcon icon={faExchangeAlt} />
                                <span>{translations.switchShop || 'Switch Shop'}</span>
                            </button>
                        )}

                        <div className="ozui-header-actions">
                            <button
                                className="ozui-action-btn clear-draft"
                                onClick={handleClear}
                                disabled={loading}
                                title={translations.clearForm || 'Clear Form'}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                                <span>{translations.clear || 'Clear'}</span>
                            </button>

                            <button
                                className="ozui-action-btn save-draft"
                                onClick={saveDraft}
                                disabled={loading}
                                title={translations.saveDraft || 'Save as Draft'}
                            >
                                <FontAwesomeIcon icon={faCopy} />
                                <span>{translations.saveDraft || 'Save Draft'}</span>
                            </button>

                            <div className="ozui-drafts-dropdown-container" ref={draftsDropdownRef}>
                                <button
                                    className="ozui-action-btn drafts-btn"
                                    onClick={() => setShowDraftsList(!showDraftsList)}
                                    title={translations.viewDrafts || 'View Drafts'}
                                >
                                    <FontAwesomeIcon icon={faFileAlt} />
                                    <span>{translations.drafts || 'Drafts'}</span>
                                    {savedDrafts.length > 0 && <span className="drafts-badge">{savedDrafts.length}</span>}
                                </button>

                                {showDraftsList && (
                                    <div className="ozui-drafts-dropdown">
                                        <div className="drafts-header">
                                            <h4>{translations.savedDrafts || 'Saved Drafts'}</h4>
                                            <button onClick={() => setShowDraftsList(false)}>×</button>
                                        </div>
                                        <div className="drafts-list">
                                            {savedDrafts.length === 0 ? (
                                                <div className="no-drafts">{translations.noDraftsSaved || 'No drafts saved'}</div>
                                            ) : (
                                                savedDrafts.map(draft => (
                                                    <div key={draft.id} className="draft-item">
                                                        <div className="draft-info" onClick={() => loadDraft(draft)}>
                                                            <div className="draft-name">
                                                                {draft.formData?.oil_number || translations.unnamedOilChange || 'Unnamed Oil Change'}
                                                            </div>
                                                            <div className="draft-details">
                                                                {draft.formData?.car_model && <span>{draft.formData.car_model}</span>}
                                                                {draft.formData?.car_number_plate && <span>{draft.formData.car_number_plate}</span>}
                                                            </div>
                                                            <div className="draft-date">
                                                                {new Date(draft.savedAt).toLocaleDateString()}
                                                            </div>
                                                        </div>
                                                        <button
                                                            className="delete-draft-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                deleteDraft(draft.id);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faTimes} />
                                                        </button>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="ozserui-form">
                <div className="ozserui-form-row">
                    <div className="ozserui-field">
                        <div className="ozserui-input-wrapper">
                            <FontAwesomeIcon icon={faHashtag} className="ozserui-input-icon" />
                            <input type="text" value={formData.oil_number} readOnly placeholder=" " />
                            <label>Oil Number</label>
                        </div>
                    </div>

                    <div className="ozserui-field">
                        <div className="ozserui-input-wrapper">
                            <FontAwesomeIcon icon={faCalendarDay} className="ozserui-input-icon" />
                            <input type="date" name="date" value={formData.date} onChange={handleChange} required placeholder=" " />
                            <label>Date *</label>
                        </div>
                    </div>

                    <div className="ozserui-customer-search-wrapper" ref={customerSearchRef}>
                        <div className="ozserui-field" style={{ flex: 1, margin: 0 }}>
                            <div className="ozserui-input-wrapper">
                                <FontAwesomeIcon icon={faSearch} className="ozserui-input-icon" />
                                <input
                                    ref={customerSearchInputRef}
                                    type="text"
                                    value={customerSearchTerm}
                                    onChange={(e) => {
                                        setCustomerSearchTerm(e.target.value);
                                        if (e.target.value !== selectedCustomer?.customer_name) {
                                            setSelectedCustomer(null);
                                        }
                                        if (e.target.value && e.target.value !== 'Walking Customer') {
                                            searchCustomers(e.target.value);
                                        } else if (e.target.value === 'Walking Customer') {
                                            setSelectedCustomer(null);
                                            setShowCustomerDropdown(false);
                                        }
                                    }}
                                    onFocus={() => {
                                        if (customerSearchTerm && customerSearchTerm !== 'Walking Customer') {
                                            searchCustomers(customerSearchTerm);
                                        }
                                    }}
                                    onKeyDown={handleCustomerKeyDown}
                                    placeholder=" "
                                    autoComplete="off"
                                />
                                <label>
                                    <FontAwesomeIcon icon={faUser} />
                                    {translations.searchCustomer || 'Search Customer'}
                                </label>
                            </div>
                            {showCustomerDropdown && customers.length > 0 && (
                                <div className="ozserui-customer-dropdown">
                                    {customers.map(customer => (
                                        <div key={customer.customerid} className="ozserui-customer-item" onClick={() => selectCustomer(customer)}>
                                            <div className="ozserui-customer-name">{customer.customer_name}</div>
                                            {customer.phone && <div className="ozserui-customer-phone">{customer.phone}</div>}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* ADDED: Phone Number Input Field for manual entry */}
                    <div className="ozserui-field">
                        <div className="ozserui-input-wrapper">
                            <FontAwesomeIcon icon={faPhone} className="ozserui-input-icon" />
                            <input
                                type="text"
                                value={manualPhoneNumber}
                                onChange={(e) => setManualPhoneNumber(e.target.value)}
                                placeholder=" "
                            />
                            <label>
                                <FontAwesomeIcon icon={faPhone} />
                                Customer Phone
                            </label>
                        </div>
                    </div>

                    <div className="ozserui-field">
                        <CarDropdown
                            value={formData.car_model}
                            onChange={handleCarModelChange}
                            shopId={shopId}
                            translations={translations}
                        />
                    </div>

                    <div className="ozserui-field">
                        <div className="ozserui-input-wrapper">
                            <FontAwesomeIcon icon={faTag} className="ozserui-input-icon" />
                            <input type="text" name="car_number_plate" value={formData.car_number_plate} onChange={handleChange} placeholder=" " />
                            <label>{translations.numberPlate || 'Number Plate'}</label>
                        </div>
                    </div>

                    <div className="ozserui-field">
                        <div className="ozserui-input-wrapper">
                            <FontAwesomeIcon icon={faTachometerAlt} className="ozserui-input-icon" />
                            <input type="text" name="odometer_reading" value={formData.odometer_reading} onChange={handleChange} placeholder=" " />
                            <label>Meter Reading</label>
                        </div>
                    </div>

                    <div className="ozserui-field">
                        <div className="ozserui-input-wrapper">
                            <FontAwesomeIcon icon={faRoad} className="ozserui-input-icon" />
                            <input
                                type="number"
                                name="mobo_oil_millage"
                                value={moboOilMillage}
                                onChange={handleMoboOilMillageChange}
                                step="100"
                                min="0"
                                placeholder=" "
                            />
                            <label>{translations.moboOilMillage || 'Mobo Oil Millage'}</label>
                        </div>
                    </div>

                    <div className="ozserui-field">
                        <div className="ozserui-input-wrapper">
                            <FontAwesomeIcon icon={faCalendarCheck} className="ozserui-input-icon" />
                            <input
                                type="text"
                                value={nextChange}
                                readOnly
                                placeholder=" "
                                style={{ backgroundColor: 'var(--ozserui-surface)', fontWeight: 'bold' }}
                            />
                            <label>{translations.nextChange || 'Next Change'}</label>
                        </div>
                    </div>
                </div>

                <div className="ozserui-form-section">
                    <div className="ozserui-product-search-wrapper" ref={productSearchRef}>
                        <div className="ozserui-field">
                            <div className="ozserui-input-wrapper">
                                <FontAwesomeIcon icon={faSearch} className="ozserui-input-icon" />
                                <input
                                    type="text"
                                    value={productSearchTerm}
                                    onChange={(e) => {
                                        setProductSearchTerm(e.target.value);
                                        searchProducts(e.target.value);
                                    }}
                                    onKeyDown={handleProductKeyDown}
                                    placeholder=" "
                                    autoComplete="off"
                                />
                                <label>
                                    <FontAwesomeIcon icon={faBarcode} />
                                    {translations.searchProducts || 'Search Products'}
                                </label>
                                {searchingProduct && <FontAwesomeIcon icon={faSpinner} spin className="ozserui-search-spinner" />}
                            </div>
                        </div>
                        {showProductDropdown && products.length > 0 && (
                            <div className="ozserui-product-dropdown">
                                {products.map(product => (
                                    <div key={product.id} className="ozserui-product-item" onClick={() => selectProduct(product)}>
                                        <div className="ozserui-product-name">{product.product_name}</div>
                                        <div className="ozserui-product-details">
                                            {product.product_code && <span>Code: {product.product_code}</span>}
                                            {product.batch_no && <span>Batch: {product.batch_no}</span>}
                                            <span>Stock: {product.quantity} packs</span>
                                        </div>
                                        <div className="ozserui-product-price">Rs. {product.sell_price_per_unit || product.sell_price}/unit</div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {selectedProducts.length > 0 && (
                        <div className="ozserui-products-used-list">
                            {selectedProducts.map((product, idx) => (
                                <ProductUsed
                                    key={product.product_id || idx}
                                    product={product}
                                    index={idx}
                                    onUpdate={(index, key, value) => {
                                        if (key === 'quantity') updateProductQuantity(index, value);
                                    }}
                                    onRemove={removeProduct}
                                    translations={translations}
                                />
                            ))}
                        </div>
                    )}
                </div>

                <div className="ozserui-form-actions">
                    <button
                        type="button"
                        className="ozserui-action-btn"
                        onClick={handlePrintReceipt}
                        disabled={selectedProducts.length === 0 && !oilDetails.oil_type}
                        title={translations.printReceipt || 'Print Receipt'}
                        style={{ background: 'var(--ozserui-primary)', color: 'white', padding: '0.5rem 1rem' }}
                    >
                        <FontAwesomeIcon icon={faPrint} />
                        <span>{translations.receipt || 'Receipt'}</span>
                    </button>

                    <button
                        type="button"
                        className="ozserui-action-btn"
                        onClick={() => setShowPaymentModal(true)}
                        style={{ background: 'var(--ozserui-primary)', color: 'white', padding: '0.5rem 1rem' }}
                    >
                        <FontAwesomeIcon icon={faPayment} />
                        <span>{translations.createPayment || 'Payment'}</span>
                    </button>

                    <button type="submit" className="ozserui-btn ozserui-btn-primary" disabled={saving || !currentShop}>
                        {saving ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin />
                                <span>{translations.saving || 'Saving...'}</span>
                            </>
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faSave} />
                                <span>{isEditMode ? (translations.updateOilChange || 'Update Oil Change') : (translations.createOilChange || 'Save Oil Change')}</span>
                            </>
                        )}
                    </button>
                </div>
            </form>

            {loading && (
                <div className="ozserui-loading-overlay">
                    <div className="ozserui-loading-content">
                        <div className="ozserui-loading-spinner"></div>
                        <p>Loading oil change data...</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OilForm;